import {
  createTask,
  CreateTaskData,
  getAttachments,
  GetAttachments,
  GetPhishingPages,
  getPhishingPages,
  getEmail,
  GetEmail,
  GetTargetList,
  getTargetList,
  getIp,
  getTargetDomain,
  getSecyTemplate,
  GetSecurityTemplate,
  GetCampaignSmtp,
  getCampaignSmtp,
  getAiEmailTemplate,
  GetAiEmailTemplate,
  createAiEmailTemplate,
  CreateAiEmailTemplate,
  getAiPhishingPageTemplate,
  GetAiPhishingPageTemplate,
  createAiPhishingPageTemplate,
  CreateAiPhishingPageTemplate,
} from '@/api/fishing-task'
import { getEmailDetail, GetEmailDetail } from '@/api/template'
import { getGroup } from '@/api/target'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { Message } from '@/components/message'

interface UseGetEmailTemplateProps {
  getEmailTemplateParams: GetEmail
}
export const useGetEmailTemplate = (props: UseGetEmailTemplateProps) => {
  const { getEmailTemplateParams } = props
  const { runAsync, data } = useRequest(() => getEmail(getEmailTemplateParams), {
    refreshDeps: [getEmailTemplateParams],
    manual: true,
  })

  return [runAsync] as const
}

interface UseGetAttachments {
  getOfficeTemplateParams: GetAttachments
}
export const useGetAttachments = (props: UseGetAttachments) => {
  const { getOfficeTemplateParams } = props

  const { data, refreshAsync: run } = useRequest(() => getAttachments(getOfficeTemplateParams), {
    refreshDeps: [getOfficeTemplateParams],
  })
  return [(data?.data.items && data?.data) || { items: [], total: 0 }, run] as const
}

interface UseGetPagesData {
  getPagesParams: GetPhishingPages
}
export const useGetPages = (props: UseGetPagesData) => {
  const { getPagesParams } = props

  const { refreshAsync: run } = useRequest(() => getPhishingPages(getPagesParams), {
    refreshDeps: [getPagesParams],
    manual: true,
  })

  return [run] as const
}

export const useGetGroup = () => {
  const { data } = useRequest(() => getGroup({}), {})

  return [data?.data?.items || []] as const
}

export const useCreateTask = () => {
  const { runAsync, loading } = useRequest((data: CreateTaskData) => createTask(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '任务创建失败')
    },
  })

  return [runAsync, loading] as const
}

export const useGetEmailDetail = () => {
  const { runAsync, loading } = useRequest((data: GetEmailDetail) => getEmailDetail(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取邮件模板失败')
    },
  })

  return [runAsync, loading] as const
}

export const useGetTargetList = () => {
  const { runAsync, loading } = useRequest((data: GetTargetList) => getTargetList(data), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取目标列表')
    },
  })

  return [runAsync, loading] as const
}
// 获取ip失败
export const useGetIp = () => {
  const { runAsync, loading, data } = useRequest(() => getIp(), {
    // manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取ip失败')
    },
  })

  return [runAsync, loading, data?.data] as const
}
// 获取可添加邮箱域名
export const useGetTargetDomain = () => {
  const { runAsync, loading, data } = useRequest(() => getTargetDomain(), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取可添加邮箱域名失败')
    },
  })

  return [runAsync, loading, data?.data?.items] as const
}

// 获取安全教育模板
export const useGetSecyTemplate = () => {
  const { runAsync, loading, data } = useRequest(
    (param: GetSecurityTemplate) => getSecyTemplate(param),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '获取安全教育模板失败')
      },
    },
  )

  return [runAsync, loading, data?.data?.items] as const
}

// 获取安全教育模板
export const useGetCampaignSmtp = () => {
  const { data, runAsync } = useRequest((param: GetCampaignSmtp) => getCampaignSmtp(param), {
    manual: true,
    onError(err: any) {
      Message.error(err?.msg || '获取发件服务器列表失败')
    },
  })

  return [data?.data?.items, runAsync] as const
}

// 获取AI邮件模板列表
export const useGetAiEmailTemplate = () => {
  const { runAsync, loading, data } = useRequest(
    (param: GetAiEmailTemplate) => getAiEmailTemplate(param),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '获取AI邮件模板列表失败')
      },
    },
  )

  return [runAsync, loading, data?.data?.items] as const
}

// 创建AI邮件模板
export const useCreateAiEmailTemplate = () => {
  const { runAsync, loading, data } = useRequest(
    (param: CreateAiEmailTemplate) => createAiEmailTemplate(param),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '创建AI邮件模板失败')
      },
    },
  )

  return [runAsync, loading, data?.data?.items] as const
}

// 获取AI钓鱼页模板列表
export const useGetAiPhishingPageTemplate = () => {
  const { runAsync, loading, data } = useRequest(
    (param: GetAiPhishingPageTemplate) => getAiPhishingPageTemplate(param),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '获取AI生成钓鱼页模板列表失败')
      },
    },
  )

  return [runAsync, loading, data?.data?.items] as const
}

// 创建AI钓鱼页模板
export const useCreateAiPhishingPageTemplate = () => {
  const { runAsync, loading, data } = useRequest(
    (param: CreateAiPhishingPageTemplate) => createAiPhishingPageTemplate(param),
    {
      manual: true,
      onError(err: any) {
        Message.error(err?.msg || '创建AI钓鱼页模板失败')
      },
    },
  )

  return [runAsync, loading, data?.data?.items] as const
}
